import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    HostListener,
    ViewChild,
    AfterViewInit,
    OnDestroy,
} from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';

import { UploadService } from '../../../../../services/upload-progress.service';
import { FileUploadConfig } from '../../../../constants/file-config.constant';

@Component({
    selector: 'file-upload',
    templateUrl: './file-upload.component.html',
    styleUrl: './file-upload.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FileUploadComponent implements AfterViewInit, OnDestroy {
    @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
    @ViewChild('overlay', { static: true }) overlayRef!: ElementRef<HTMLElement>;
    @ViewChild('uploadBox') uploadBoxRef!: ElementRef<HTMLElement>;
    isDragOver = false;
    fileUploadConfig = FileUploadConfig;

    /**
     *
     * @param _uploadService
     * @param router
     */
    constructor(
        private _uploadService: UploadService,
        private router: Router
    ) {
        this.router.events
            .pipe(filter((event) => event instanceof NavigationStart))
            .subscribe(() => {
                if (this._uploadService.showFileUpload()) {
                    this.closeModal();
                }
            });
    }

    private movedOverlay = false;
    private originalParent: Node | null = null;

    /**
     *
     */
    ngAfterViewInit(): void {
        // Move the overlay element to document.body and make it fixed so it blocks background interactions
        try {
            if (
                this.overlayRef &&
                this.overlayRef.nativeElement &&
                typeof document !== 'undefined'
            ) {
                const el = this.overlayRef.nativeElement as HTMLElement;
                this.originalParent = el.parentElement;
                document.body.appendChild(el);
                el.style.position = 'fixed';
                el.style.top = '0';
                el.style.left = '0';
                el.style.width = '100%';
                el.style.height = '100%';
                el.style.zIndex = '200100';
                el.style.pointerEvents = 'auto';
                this.movedOverlay = true;
            }
        } catch (e) {
            /* noop */
        }
    }

    /**
     *
     */
    ngOnDestroy(): void {
        try {
            if (
                this.movedOverlay &&
                this.overlayRef &&
                this.overlayRef.nativeElement &&
                this.originalParent
            ) {
                const el = this.overlayRef.nativeElement as HTMLElement;
                this.originalParent.appendChild(el);
            }
        } catch (e) {
            /* noop */
        }
    }

    /**
     *
     */
    triggerFileInput() {
        this.fileInput.nativeElement.click();
    }

    /**
     *
     * @param event
     */
    onFileSelected(event: Event) {
        const input = event.target as HTMLInputElement;
        if (!input.files) {
            return;
        }

        const file = input.files[0];
        this._uploadService.setFile(file);
    }

    /**
     *
     * @param event
     */
    onDragOver(event: DragEvent) {
        event.preventDefault();
        this.isDragOver = true;
    }

    /**
     *
     * @param event
     */
    onDragLeave(event: DragEvent) {
        event.preventDefault();
        this.isDragOver = false;
    }

    /**
     *
     * @param event
     */
    onDrop(event: DragEvent) {
        event.preventDefault();
        this.isDragOver = false;

        const file = event.dataTransfer?.files?.[0];
        if (!file) {
            return;
        }
        this._uploadService.setFile(file);
    }

    /**
     *
     * @param event
     */
    onOverlayClick(event: MouseEvent): void {
        const target = event.target as Node | null;
        const uploadBox = this.uploadBoxRef?.nativeElement;

        if (!target || !uploadBox || uploadBox.contains(target)) {
            return;
        }

        this.closeModal();
    }

    /**
     *
     * @param event
     */
    @HostListener('document:keydown.escape', ['$event'])
    onEscape(event: Event): void {
        if (this._uploadService.showFileUpload()) {
            this.closeModal();
        }
    }

    /**
     *
     */
    closeModal() {
        this._uploadService.closeFileUpload();
        this.clearStates();
    }

    /**
     *
     */
    clearStates() {
        this._uploadService.clearAll();
    }
}
